import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartBar from '../../../../components/charts/ChartBar'
import ChartBarSkeleton from '../../../../components/skeletons/ChartBarSkeleton'
import { ChartBarThemes } from '../../../../components/charts/types/ChartBar'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
// import { GET_CART_CHANGE_OPENED_USERS } from '../../../../queries/cartChange'

const GET_CART_CHANGE_OPENED_USERS = gql` 
  query GetMostOpenedUsers($filters: EventCartChangeFilter) {
    eventCartChangeAggs(
      filters: $filters,
      index: "eventos-fapp-cart-change-opened*",
      size: 0,
      aggs: {
        users: {
          terms: {
            field: "clientId",
            size: 5
          }
        }
      }
    ) {
      aggregations
    }
  }
`
interface Bucket {
  key: string
  doc_count: number,
  views: {
    value: number
  }
}
const CartChangeOpenedUsers = (): JSX.Element => {
  const { filters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_CART_CHANGE_OPENED_USERS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartBarSkeleton />
  if (loading || !data) return <ChartBarSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.eventCartChangeAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.eventCartChangeAggs.aggregations.users
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'most-opened-users'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    }
  }

  const series = [{
    name: 'Operações',
    data: seriesData
  }]
  if (!data) return <></>
  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      Top 5 usuários que mais visualizaram a modal de troca de cesta
    </Typography>
    <ChartBar options={options} series={series} theme={ChartBarThemes.blue} height={400} />
  </Paper>
}
export default CartChangeOpenedUsers
